// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e34eeae6","57":"8a5f832b","196":"73c7ed0a","317":"3995885d","427":"b45182c5","498":"45150cc1","545":"36a4cbeb","591":"5bc36578","603":"5f8c0e82","800":"2ee2c42e","926":"b6db9865"}[chunkId] + ".chunk.js";
};